<app-notifications></app-notifications>

@if (isAuthenticated() && showBrowserNotificationAd) {
  <div class="browser-notification-prompt text-center">
    <span>Would you like to enable browser notifications?</span>
    <span class="browser-notification-prompt__actions">
      <button mat-button (click)="enableBrowserNotification()">Yes</button>
      <button mat-button (click)="declineBrowserNotification()">No</button>
    </span>
  </div>
}

@if (loaded === true && offline === true) {
  <div class="red-bar d-flex">
    <div class="d-flex mx-auto flex-column">
      <mat-spinner [diameter]="24" [strokeWidth]="2" class="mx-auto my-auto" color="warn"></mat-spinner>
      <span>Attempting to connect</span>
    </div>
  </div>
}

<app-header
  [header]="header"
  [sid]="sid"
  [loggedIn]="isAuthenticated()"
  [authLoaded]="authResolved()"
  [userName]="firstName()"
  [searchTerm]="headerSearchTerm"
  (searchSubmit)="handleHeaderSearch($event)"
  (signInClick)="openLoginDialog()"
  (logout)="logout()"
></app-header>

<p-dialog
  [(visible)]="loginDialogVisible"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [showHeader]="false"
  [appendTo]="'body'"
  [maskStyleClass]="enableBackGroundBlur ? 'login-dialog-mask-blur' : ''"
  [style]="{ width: '347px' }"
  [breakpoints]="{ '960px': '95vw', '640px': '95vw' }"
  [contentStyle]="{ padding: '0', maxHeight: '90vh', overflow: 'auto' }"
  styleClass="login-dialog"
  (onHide)="handleLoginDialogHide()"
>
  @if (loginDialogVisible) {
    <app-login
      [isDialog]="true"
      [redirectPathname]="loginDialogPathname"
      (dialogClosed)="handleLoginDialogClosed()"
    ></app-login>
  }
</p-dialog>

@if (loading) {
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}
@if (loading || offline) {
  <div class="loading-outer-bg"></div>
}

<mat-toolbar
  class="no-print subheader-toolbar"
  [class.subheader-toolbar--auction]="isAuctionSection"
  [class.subheader-toolbar--profile]="isProfileSection"
  [class.subheader-toolbar--rasmus-tv]="isRasmusTvSection"
>
  <div class="subheader-inner">
    <div class="subheader-left">
      <p-select
        class="pill-control overlay-control subheader-select"
        [options]="categoryOptions"
        [(ngModel)]="selectedCategory"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        [checkmark]="false"
        [panelStyleClass]="selectPanelClass"
        [appendTo]="'body'"
        aria-label="Filter auctions by category"
        placeholder="Shop by category"
        (onChange)="onCategoryChange($event.value)"
      >
        <ng-template pTemplate="selectedItem">
          <span class="subheader-select__placeholder">Shop by category</span>
        </ng-template>
        <ng-template pTemplate="dropdownicon">
          <svg class="subheader-select__chevron" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L5.75 4.68934L10.2197 0.21967C10.5126 -0.0732233 10.9874 -0.0732233 11.2803 0.21967C11.5732 0.512563 11.5732 0.987437 11.2803 1.28033L6.28033 6.28033C5.98744 6.57322 5.51256 6.57322 5.21967 6.28033L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z" fill="#020617"/>
          </svg>
        </ng-template>
      </p-select>
    </div>

    <span class="subheader-divider" aria-hidden="true"></span>

    <div class="subheader-center">
      <button
        pButton
        type="button"
        class="special-offer"
        routerLink="/referrals"
      >
        <span class="special-offer__text">
          <span class="special-offer__label">Special offer:</span>
          <span class="special-offer__message">Get a 20% referral payout*</span>
        </span>
        <span class="special-offer__divider" aria-hidden="true"></span>
        <span class="special-offer__cta">
          <span class="special-offer__cta-text">Refer Now</span>
          <svg class="special-offer__cta-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <g clip-path="url(#clip0_3540_1756)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.16667C3.77834 1.16667 1.16667 3.77834 1.16667 7C1.16667 10.2217 3.77834 12.8333 7 12.8333C10.2217 12.8333 12.8333 10.2217 12.8333 7C12.8333 3.77834 10.2217 1.16667 7 1.16667ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7.41248 3.47641L10.5236 6.58752C10.6375 6.70142 10.6944 6.85071 10.6944 7C10.6944 7.07909 10.6787 7.15451 10.6502 7.22329C10.6217 7.29209 10.5795 7.35655 10.5236 7.41248L7.41248 10.5236C7.18467 10.7514 6.81533 10.7514 6.58752 10.5236C6.35972 10.2958 6.35972 9.92644 6.58752 9.69863L8.70282 7.58333H3.88889C3.56672 7.58333 3.30556 7.32217 3.30556 7C3.30556 6.67783 3.56672 6.41667 3.88889 6.41667H8.70282L6.58752 4.30137C6.35972 4.07356 6.35972 3.70422 6.58752 3.47641C6.81533 3.2486 7.18467 3.2486 7.41248 3.47641Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_3540_1756">
                <rect width="14" height="14" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
      </button>

      <nav class="subheader-nav subheader-nav--center" aria-label="Subheader primary links">
        @for (link of centerNavLinks; track link.label) {
          @if (link.href) {
            <a class="subheader-nav__link" [href]="link.href">
              {{ link.label }}
            </a>
          } @else {
            <a class="subheader-nav__link" [routerLink]="link.routerLink">
              {{ link.label }}
            </a>
          }
        }
      </nav>
    </div>

    <div class="subheader-right">
      <div class="subheader-right-group">
        <nav class="subheader-nav subheader-nav--right" aria-label="Subheader support links">
          @for (link of rightNavLinks; track link.label) {
            <a class="subheader-nav__link" [routerLink]="link.routerLink">
              {{ link.label }}
            </a>
          }
          <button
            type="button"
            class="subheader-link"
            aria-haspopup="true"
            aria-label="Open more menu"
            (click)="morePanel.toggle($event)"
          >
            More
            <svg class="subheader-chevron" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none" aria-hidden="true">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L5.75 4.68934L10.2197 0.21967C10.5126 -0.0732233 10.9874 -0.0732233 11.2803 0.21967C11.5732 0.512563 11.5732 0.987437 11.2803 1.28033L6.28033 6.28033C5.98744 6.57322 5.51256 6.57322 5.21967 6.28033L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z" fill="#020617"/>
            </svg>
          </button>
          <p-popover #morePanel [styleClass]="'subheader-panel'">
            <div class="more-panel">
              @for (link of moreMenuLinks; track link.label) {
                <a class="more-item" [routerLink]="link.routerLink" (click)="morePanel.hide()">
                  {{ link.label }}
                </a>
              }
            </div>
          </p-popover>
        </nav>
      </div>
    </div>
  </div>

  @if (filtering) {
    <div class="middle"></div>
  }

</mat-toolbar>
